import usePushNotifications from '@/hooks/usePushNotifications';

export default function PushNotificationsHost() {
  usePushNotifications();
  return null;
}
